// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Home from "./Home/Home";
import About from "./Home/About";
import ProjectSection from "./Home/ProjectSection";
import OurBusiness from "./Home/OurBusiness";
import LatestNews from "./Home/LatestNews";
import Navbar from "./Home/Navbar";
import Footer from "./Home/Footer";
import LogoSplash from "./LogoSplash";
import './i18n'; // i18n configuration

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
};

// Wrapper component to use `useLocation` within Router
const AppContent = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<ProjectSection />} />
        <Route path="/business" element={<OurBusiness />} />
        <Route path="/news" element={<LatestNews />} />
      </Routes>
      <Footer />
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LogoSplash />;

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
